
















































import { shortTimeAgo } from '@/helpers/date-utils';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import { ICampaign, IEmail } from '@/store/types';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'EmailPreviewTooltip',
  mixins: [CopyToClipboard],
  props: {
    email: {
      type: Object as PropType<IEmail>,
    },
    campaign: {
      type: Object as PropType<ICampaign>,
    },
  },
  data() {
    return {
      shortTimeAgo,
    };
  },
  computed: {
    ...mapGetters(['surveyChoices']),
  },
  methods: {
    view(email: IEmail) {
      this.$emit('view', email);
    },
  },
});
